import * as d3 from 'd3';
import {ScaleLinear} from 'd3';

import {RingLayout} from 'molbio/maps/circular/CircularLayout';
import RingComponent, {RingComponentOptions} from 'molbio/maps/circular/RingComponent';
import {getAngle} from 'util/geometry/GeometryUtil';

abstract class RingView<TLayout extends RingLayout> extends RingComponent<TLayout> {
  radius!: ScaleLinear<number, number>;
  radiusIn!: ScaleLinear<number, number>;

  initialize(options: RingComponentOptions<TLayout>): void {
    super.initialize(options);

    this.radius = d3.scaleLinear().domain([0, 1]);
    this.radiusIn = d3.scaleLinear().domain([0, 1]);
    this.updateRadius();
  }

  isShown(): boolean {
    return true;
  }

  radiusFromInner(layer: number, innerRadius: number): ScaleLinear<number, number> {
    return d3
      .scaleLinear()
      .domain([layer, layer + 1])
      .range([innerRadius, innerRadius + this.layout.get('ringHeight')]);
  }

  layerBounds(layer: number, innerRadius: number | null = null): {innerRadius: number; outerRadius: number} {
    // @ts-expect-error: This seems like a legitimate bug
    const radius = innerRadius != null ? this.radiusFromInner(innerRadius) : this.radius;

    return {
      innerRadius: radius(layer),
      outerRadius: radius(layer + 1) - this.layout.vMargin(),
    };
  }

  updateRadius(): void {
    this.radius.range([this.getInnerRadius(), this.getInnerRadius() + this.layout.get('ringHeight')]);
    this.radiusIn.range([this.getOuterRadius(), this.getOuterRadius() - this.layout.get('ringHeight')]);
  }

  setInnerRadius(r: number): void {
    this.layout.set('innerRadius', r);
    this.updateRadius(); // always update.
    this.update();
  }

  setOuterRadius(r: number): void {
    this.layout.set('outerRadius', r);
    this.updateRadius(); // always update.
    this.update();
  }

  getInnerRadius(): number {
    return this.layout.get('innerRadius');
  }

  getOuterRadius(): number {
    return this.layout.get('outerRadius');
  }

  getOffset(): number {
    return getAngle(this.model.get('DNAOffset'), this.model.get('sequence').length());
  }

  computeOuterRadius(innerRadius: number): number {
    return innerRadius;
  }

  render(): this {
    return this;
  }
}

export {RingView};
